
import React from 'react'
import {Link} from 'react-router-dom'
import abimg from '../../images/knoweb.webp'
import spimg1 from '../../images/ab-shape-1.png'
import spimg2 from '../../images/ab-shape-2.png'
import spicon from '../../images/icon/badge.svg'
import sign from '../../images/signeture.png'


const About2 = (props) => {
    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }
    return(
        <section className={`wpo-about-section ${props.abClass}`}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-12 col-12">
                        <div className="wpo-about-wrap">
                        <div className="wpo-about-img">
                            <img src={abimg} alt=""/>
                            <div className="wpo-ab-shape-1"><img src={spimg1} alt=""/></div>
                            <div className="wpo-ab-shape-2"><img src={spimg2} alt=""/></div>
                        </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                        <div className="wpo-about-text">
                        <div className="wpo-about-icon">
                            <div className="icon">
                                <img src={spicon} alt=""/>
                            </div>
                        </div>
                        <div className="wpo-about-icon-content">
                            <h2>Who are <span>Knoweb</span>, More Than Just a Tech Company</h2>
                            <p>Knoweb Solutions is a forward-thinking digital agency dedicated to helping businesses succeed through technology. We specialize in custom software development, web and mobile applications, and results-driven digital marketing strategies. Our team combines creativity, technical expertise, and business insight to deliver solutions that are not only beautiful but also scalable and impactful.</p>
                            {/* <div className="signeture">
                                <span><img src={sign} alt=""/></span>
                                <p>Robert William, CEO</p>
                            </div> */}
                            <Link onClick={ClickHandler} to="/service" className="btn theme-btn" >View Our Services</Link>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About2;